import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./StudentInformation.module.sass";
import Item from "../Item";
import TextInput from "../../../components/TextInput";
import { searchStudents } from "../../../services/student.service";
import LetterAvatar from "../../../components/LetterAvatar";

const StudentInformation = ({ className, data, onSelectStudent }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showResults, setShowResults] = useState(false);

  // Effectuer la recherche lorsque la requête change
  useEffect(() => {
    const fetchStudents = async () => {
      if (searchQuery.length >= 2) {
        try {
          const results = await searchStudents(searchQuery);
          setSearchResults(results);
          setShowResults(true);
        } catch (error) {
          console.error('Erreur lors de la recherche des étudiants:', error);
          setSearchResults([]);
          setShowResults(false);
        }
      } else {
        setSearchResults([]);
        setShowResults(false);
      }
    };
    
    fetchStudents();
  }, [searchQuery]);

  // Gérer la sélection d'un étudiant
  const handleSelectStudent = (student) => {
    setSelectedStudent(student);
    setSearchQuery(`${student.first_name} ${student.last_name}`);
    setShowResults(false);
    
    // Transmettre l'étudiant sélectionné au composant parent si la prop existe
    if (onSelectStudent) {
      console.log('StudentInformation - Envoi de l\'étudiant au parent:', student);
      onSelectStudent(student);
    }
  };

  // Gérer le changement dans la barre de recherche
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    if (selectedStudent && e.target.value !== `${selectedStudent.first_name} ${selectedStudent.last_name}`) {
      setSelectedStudent(null);
    }
  };

  return (
    <Item
      className={cn(styles.card, className)}
      title="Étudiant(e)"
      classTitle="title-red"
    >
      <div className={styles.fieldset}>
        <div className={styles.searchContainer}>
          <TextInput
            className={styles.field}
            label="Rechercher un(e) étudiant(e)"
            name="student-search"
            type="text"
            placeholder="Nom, email ou téléphone (min. 2 caractères)"
            tooltip="Recherchez par nom, email ou téléphone"
            value={searchQuery}
            onChange={handleSearchChange}
            required
          />
          
          {showResults && searchResults.length > 0 && (
            <div className={styles.searchResults}>
              {searchResults.map(student => (
                <div 
                  key={student.id} 
                  className={styles.resultItem}
                  onClick={() => handleSelectStudent(student)}
                >
                  <div className={styles.resultContent}>
                    <div style={{ marginRight: '20px' }}>
                      <LetterAvatar
                        firstName={student.first_name}
                        lastName={student.last_name}
                        size={40}
                      />
                    </div>
                    <div className={styles.companyInfo}>
                      <div className={styles.companyName}>{student.first_name} {student.last_name}</div>
                      <div className={styles.companyDetails}>
                        <span>{student.email}</span>
                        <span>•</span>
                        <span>{student.phone}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {showResults && searchResults.length === 0 && searchQuery.length >= 2 && !selectedStudent && (
            <div className={styles.noResults}>
              Aucun étudiant trouvé
            </div>
          )}
        </div>

        {selectedStudent && (
          <div className={styles.selectedCompanyDetails}>
            <h3>Détails de l'étudiant sélectionné</h3>
            <div className={styles.detailRow}>
              <span className={styles.label}>Nom:</span>
              <span className={styles.value}>{selectedStudent.first_name} {selectedStudent.last_name}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Email:</span>
              <span className={styles.value}>{selectedStudent.email || 'Non renseigné'}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Téléphone:</span>
              <span className={styles.value}>{selectedStudent.phone || 'Non renseigné'}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>Date de naissance:</span>
              <span className={styles.value}>
                {selectedStudent.birth_date ? 
                  new Date(selectedStudent.birth_date).toLocaleDateString('fr-FR') : 
                  'Non renseignée'}
              </span>
            </div>
            {selectedStudent.type && (
              <div className={styles.detailRow}>
                <span className={styles.label}>Type:</span>
                <span className={styles.value}>{selectedStudent.type}</span>
              </div>
            )}
            {selectedStudent.status && (
              <div className={styles.detailRow}>
                <span className={styles.label}>Statut:</span>
                <span className={styles.value}>{selectedStudent.status}</span>
              </div>
            )}
            <div className={styles.detailRow}>
              <span className={styles.label}>RQTH:</span>
              <span className={styles.value}>
                <input 
                  type="checkbox" 
                  checked={selectedStudent.is_rqth || false}
                  disabled
                  style={{ marginLeft: '8px' }}
                />
                {selectedStudent.is_rqth ? ' Oui' : ' Non'}
              </span>
            </div>
          </div>
        )}
      </div>
    </Item>
  );
};

export default StudentInformation;